<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <title-comp/>
      </v-col>
    </v-row>
    <v-row class="ml-n8 mr-n8">
      <v-col cols="12">
        <v-data-table
          v-if="!(matchingContacts!=null && matchingContacts.length==0 && totalFound>0)"
          :headers="headers"
          @click:row="onRowClicked"
          :items="preparedContacts"
          :custom-key-sort="customKeySort"
          >
        </v-data-table>
        <h2 v-else><br>Too many results:<br>{{totalFound}} contacts found (>100)</h2>
      </v-col>
    </v-row>

    <!-- Search Menu -->
    <v-row no-gutters>
      <v-col cols="12">
        <v-dialog v-model="appevent.openSearchMenu" transition="dialog-top-transition" width="100%" height="100vh" persistent>
          <v-card width="Auto">
            <v-form validate-on="submit lazy" @submit.prevent="runSearch"
              style="border-top:1px solid gray;">
              <v-text-field
                prepend-inner-icon="mdi-text-box-outline"
                v-model="filter.FirstNameLastName"
                clearable
                label="Nom et/ou Prénom"/>

                <StatesSelector
                  label="Candidate states"
                  :items="refstore.CandidateStates"
                  v-model="filter.SelectedCandStates"
                  multiple/>

              <v-container class="ma-0 pa-0" fluid>
                <SkillsSelector :filter="filter"/>
              </v-container>
              <ProfileSelector :filter="filter"/>
              <ContactAutocomplete
                        label="Relatif au(x) sales"
                        v-model="filter.SelectedSales"
                        :onSearch="onSearchSalesSuperv"
                        prepend-inner-icon="mdi-handball"
                        multiple
                      />
              <v-text-field
                prepend-inner-icon="mdi-gauge"
                v-model="filter.Xp"
                v-mask="'00'"
                label="Xp min"/>
            </v-form>

            <!-- Actions -->
            <template v-slot:actions>
              <v-btn class="ms-auto" text="&#x1F9F9; Vider" @click="cleanFilter"></v-btn>
              <v-btn class="ms-auto" text="&#128269; Chercher" @click="runSearch"></v-btn>
              <v-btn class="ms-auto" text="&#10060; Fermer" @click="closeSearch"></v-btn>
            </template>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <!-- Detail -->
    <v-row no-gutters>
      <v-col cols="12">
        <v-dialog v-model="openRowDetail" transition="dialog-top-transition" width="100%" height="100vh" persistent>
          <v-card width="Auto">
            <v-container>
            <v-row no-gutters>
              <v-col cols="12">
                <div class="section_main_title">{{ viewContact.firstName }}&nbsp;{{ viewContact.lastName }}</div>
                <div class="section_title">&#x2022; STATUS INFOS</div>
                <div class="section_content" v-if="viewContact.lastCandidateActivity==null">
                  N/A
                </div>
                <div  class="section_content">
                  <activity-infos :activity="viewContact.lastCandidateActivity"></activity-infos>
                  <div>
                    <span>&#x1F4DE;: <a :href="'tel:' + viewContact.phone">{{ viewContact.phone }}</a></span> |
                    <span>&#x2709;: <a :href="'mailto:' + viewContact.email">{{ viewContact.email }}</a></span>
                  </div>
                </div>
                <hr>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <div style="padding-top: 1vh;"></div>
                <div class="section_title">&#x2022; POSITIONS</div>
                <div class="section_content" v-if="viewContact.lastCustomerPosition==null && viewContact.lastInvivooPosition==null">
                  N/A
                </div>
                <div class="section_content" v-if="viewContact.lastCustomerPosition || viewContact.lastInvivooPosition">
                  <PositionInfos :position="viewContact.lastInvivooPosition"></PositionInfos>
                  <PositionInfos :position="viewContact.lastCustomerPosition"></PositionInfos>
                  <div style="color: #777777;">
                    <div><b>Résumé:&nbsp;</b><i>{{ viewContact.resumeMainPos }}</i></div>
                    <div><b>Last XP:&nbsp;</b><i>{{ viewContact.resumeExp }}</i></div>
                  </div>
                </div>
                <hr>
              </v-col>
            </v-row>
            <!-- Skills-->
            <v-row no-gutters>
              <v-col cols="12">
                <div style="padding-top: 1vh;"></div>
                <div class="section_title">&#x2022; SKILLS</div>
                <div class="section_content" v-if="viewContact.contactSkills==null">
                  N/A
                </div>
                <div class="section_content" v-if="viewContact.contactSkills">
                <span v-for="s in viewContact.contactSkills" :key="s">{{ s }}, </span>
                </div>
                <hr>
              </v-col>
            </v-row>
              <v-row no-gutters>
                <v-col cols="12">
                  <div style="padding-top: 1vh;"></div>
                  <div class="section_title">&#x2022; DOCUMENTS</div>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="5"/>
                <v-col cols="2">
                  <Spinner style="text-align: center;" v-if="docList == null"/>
                </v-col>
                <v-col cols="5"/>
              </v-row>
              <template v-if="docList != null && filteredDocList.length>0">
                <v-row @click="downloadDocument(d.docId)" no-gutters v-for="d in filteredDocList" :key="d.docId" class="liste-doc-class section_content">
                  <v-col cols="12" style="padding-top: 1%; padding-bottom: 1%;">
                    <p>&#x1F441;</p> [{{d.date}}] {{d.name}}
                  </v-col>
                </v-row>
              </template>
              <template v-if="docList != null && filteredDocList.length==0">
                  <div style="font-family: aldrich; border-top: 1px solid black; padding-top: 2%;">Aucun document/CV trouvé &#x1f63f;</div>
                  <div v-if="viewAllDocs==false" style="font-family: aldrich;">&#128071; Essaye "[&#x2714;] TOUS LES DOCS"</div>
              </template>
            </v-container>
            <hr>
            <template v-slot:actions>
              <v-btn
                v-html="toutVoirtext"
                @click="viewAllDocs=!viewAllDocs"
                color="black lighten-1">
              </v-btn>
              <v-btn class="ms-auto" text="&#10060; Fermer" @click="openRowDetail=false"></v-btn>
            </template>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ContactFilteringCategoryEnum from '@/utils/ContactFilteringCategoryEnum.js'
import TitleComp from '@/components/TitleComp.vue'
import PositionInfos from '@/components/PositionInfos.vue'
import SkillsSelector from '@/components/SkillsSelector.vue'
import StatesSelector from '@/components/StatesSelector.vue'
import ProfileSelector from '@/components/ProfileSelector.vue'
import ActivityInfos from '@/components/ActivityInfos.vue'
import { AppEventsStore, ReferentialStore } from '@/stores'
import { DatabaseServiceInstance } from '@/database'
import { LynxUtils } from '@/utils'
import { ContactSvcInstance, DocSvcInstance } from '@/lynxapi'
import Spinner from '@/components/Spinner.vue'
import ContactAutocomplete from '@/components/ContactAutocomplete.vue'
import '@/assets/viewdetailstyles.css'
const moment = require('moment')

export default {
  components: {
    TitleComp,
    SkillsSelector,
    StatesSelector,
    ProfileSelector,
    Spinner,
    PositionInfos,
    ActivityInfos,
    ContactAutocomplete
  },
  computed: {
    appevent: function () {
      return AppEventsStore()
    },
    refstore: function () {
      return ReferentialStore()
    },
    utils: function () {
      return LynxUtils
    },
    preparedContacts: function () {
      return this.matchingContacts.map(cand => ({
        ...cand,
        fullName: `${cand.firstName} ${cand.lastName}`
      }))
    },
    filteredDocList: function () {
      if (!this.docList) {
        return []
      }
      if (this.viewAllDocs === true) {
        return this.docList
      }
      // Filtrer pour ne garder que les éléments contenant "cv" dans name, indépendamment de la casse
      const filteredList = this.docList.filter(item => item.name.toLowerCase().includes('cv'))

      // Trouver l'élément avec la date la plus récente
      const mostRecent = filteredList.reduce((latest, item) => {
        return (moment(latest.date, 'DD/MM/YYYY') > moment(item.date, 'DD/MM/YYYY')) ? latest : item
      }, filteredList[0]) // Initialise avec le premier élément du tableau filtré
      if (mostRecent) {
        return [mostRecent]
      }
      return []
    },
    toutVoirtext: function () {
      let s = ''
      if (this.viewAllDocs === true) {
        s = '&#x2705;'
      } else {
        s = '&#x2B1C;'
      }
      s += ' TOUS LES DOCS'
      return s
    }
  },
  data: () => ({
    filter: {
      FirstNameLastName: '',
      SelectedCandStates: [],
      SelectedSkills: [],
      Allskills: false,
      SelectedPositionTypes: [],
      SelectedSales: [],
      Xp: null
    },
    foundSalesSuperv: [],
    matchingContacts: [],
    totalFound: 0,
    openRowDetail: false,
    viewContact: null,
    docList: null,
    viewAllDocs: false,
    headers: [
      {
        title: 'Name',
        align: 'start',
        sortable: true,
        key: 'fullName'
      },
      { title: 'XP', key: 'xp' },
      { title: 'Dispo', key: 'dispo' },
      { title: 'Profile', key: 'profile' }
    ],
    customKeySort: {
      dispo: (a, b) => {
        const today = new Date()

        const parseValue = (value) => {
          if (!value) return Infinity
          const v = value.toUpperCase().trim()

          // 1) ASAP => aujourd’hui
          if (v === 'ASAP') {
            return today.getTime()
          }

          // 2) XM => X mois après aujourd’hui
          const monthMatch = /^(\d+)M$/.exec(v)
          if (monthMatch) {
            const months = Number(monthMatch[1])
            const d = new Date(today)
            d.setMonth(d.getMonth() + months)
            return d.getTime()
          }

          // 3) Date jj/MM/AAAA
          const dateMatch = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(v)
          if (dateMatch) {
            const [, day, month, year] = dateMatch
            return new Date(Number(year), Number(month) - 1, Number(day)).getTime()
          }

          // 4) Tout le reste = on place à la fin
          return Infinity
        }

        return parseValue(a) - parseValue(b)
      }
    }
  }),
  methods: {
    async onRowClicked (event, item) {
      this.openRowDetail = true
      this.viewContact = item.item
      this.docList = null
      this.docList = await DocSvcInstance.findDocumentsForContact(this.viewContact.contactId)
    },
    async downloadDocument (docId) {
      await DocSvcInstance.downloadDocument(docId)
    },
    runSearch: async function () {
      DatabaseServiceInstance.saveFilter('cand', this.filter)
      const res = await ContactSvcInstance.findMatchingCandidates(this.filter)
      this.matchingContacts = res?.result
      this.totalFound = res?.count
      this.closeSearch()
    },
    closeSearch: function () {
      this.appevent.openSearchMenu = false
    },
    cleanFilter: function () {
      this.filter = {}
    },
    onSearchSalesSuperv: async function (searchInput) {
      return await ContactSvcInstance.autocompleteContact(searchInput, ContactFilteringCategoryEnum.SALES, true)
    },
    closeDropdown: function (truc) {
      // Accède à la référence de v-autocomplete et déclenche la méthode blur pour fermer le menu
      this.$refs.autocomplete2.blur()
    }
  },
  async mounted () {
    this.filter = await DatabaseServiceInstance.loadFilter('cand')
  },
  watch: {
    'appevent.openSearchMenu': async function (newval, oldval) {
      if (newval === true) {
        this.filter = await DatabaseServiceInstance.loadFilter('cand')
      }
    }
  }
}
</script>
